import { forwardRef } from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => (
  <input
    ref={ref}
    className="w-full p-3 bg-secondary-dark placeholder-white placeholder-opacity-80 text-white text-base rounded-full text-center focus:outline-none"
    {...props}
  />
));
